//Gets all buttons
const laiteFilterButtons = document.querySelector(".filter-buttons")?.children;
console.debug(laiteFilterButtons);
//Adds function to buttons

if (laiteFilterButtons !== null && laiteFilterButtons !== undefined) {
  Array.from(laiteFilterButtons).forEach((laiteFilterButton) => {
    laiteFilterButton.addEventListener("click", function handleClick(event) {
      const filteredClass = laiteFilterButton.id;

      const disclaimer = document.querySelector('#disclaimer')
      disclaimer.className = "";
      disclaimer.classList.add(filteredClass);

      //Gets currently active button and removes filter-active class from it.
      const filterActive = document.querySelector(".filter-active");
      if (filterActive !== null) {
        filterActive.classList.remove("filter-active");
      }

      //Adds filter-active class to clickedf button
      laiteFilterButton.classList.add("filter-active");

      //Adds classes to correct laitteet
      if (filteredClass !== "kaikki") {
        const laitteet = document.querySelectorAll(
          ".tease-laite:not(." + filteredClass + ")",
        );

        laitteet.forEach((laite) => {
          laite.classList.add("filtered");
        });

        const filteredLaitteet = document.querySelectorAll("." + filteredClass);
        filteredLaitteet.forEach((filteredLaite) => {
          filteredLaite.classList.remove("filtered");
        });
      } else {
        const laitteet = document.querySelectorAll(".tease-laite");

        laitteet.forEach((laite) => {
          laite.classList.remove("filtered");
        });
      }
    });
  });
}

//Gets rajoitus param
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

let rajoitusQuery = params.rajoitus;

//Filters if param was passed in
if (rajoitusQuery !== null) {
  const b = document.querySelector('#'+rajoitusQuery);
  if(!!b) b.click();
}